import React from 'react';

const GameSummary = ({ gameData, plays }) => {
    const countEventsByTeam = () => {
        let homeShots = 0;
        let awayShots = 0;
        let homeStats = {
            faceoffWins: 0, totalFaceoffs: 0, penaltyMinutes: 0,
            hits: 0, blockedShots: 0, giveaways: 0, takeaways: 0
        };
        let awayStats = { ...homeStats };

        plays.forEach(play => {
            if (!play.details) return;
            const eventOwnerTeam = play.details.eventOwnerTeamId;
            const isHomeTeam = eventOwnerTeam === gameData?.homeTeam?.id;
            const team = isHomeTeam ? homeStats : awayStats;
            
            switch (play.typeDescKey) {
                case 'shot-on-goal':
                    if (isHomeTeam) {
                        homeShots += 1;
                    } else {
                        awayShots += 1;
                    }
                    break;
                case 'faceoff':
                    homeStats.totalFaceoffs += 1;
                    awayStats.totalFaceoffs += 1;
                    if (isHomeTeam) {
                        homeStats.faceoffWins += 1;
                    } else {
                        awayStats.faceoffWins += 1;
                    }
                    break;
                case 'penalty': team.penaltyMinutes += 2; break;
                case 'hit': team.hits += 1; break;
                case 'blocked-shot': team.blockedShots += 1; break;
                case 'giveaway': team.giveaways += 1; break;
                case 'takeaway': team.takeaways += 1; break;
                default: break;
            }
        });

        homeStats.shots = homeShots;
        awayStats.shots = awayShots;

        homeStats.faceoffPct = homeStats.totalFaceoffs > 0 ? ((homeStats.faceoffWins / homeStats.totalFaceoffs) * 100).toFixed(1) : '0';
        awayStats.faceoffPct = awayStats.totalFaceoffs > 0 ? ((awayStats.faceoffWins / awayStats.totalFaceoffs) * 100).toFixed(1) : '0';
        return { homeStats, awayStats };
    };

    const { homeStats, awayStats } = countEventsByTeam();

    return (
        <div className="bg-white shadow rounded-lg p-6 text-center">
            <h2 className="text-2xl font-bold mb-4">Game Stats</h2>
            <div className="grid grid-cols-3 text-xl font-bold mt-4 items-center">
                <div className="flex flex-col items-center">
                    <img src={gameData.awayTeam?.logo} className="h-16 mb-2" alt="Away Team Logo" />
                    <p>{gameData.awayTeam?.abbrev}</p>
                </div>
                <div></div>
                <div className="flex flex-col items-center">
                    <img src={gameData.homeTeam?.logo} className="h-16 mb-2" alt="Home Team Logo" />
                    <p>{gameData.homeTeam?.abbrev}</p>
                </div>
            </div>
            <div className="grid grid-cols-3 text-xl font-bold mt-4">
                <p>{awayStats.shots}</p>
                <p className="text-center">Shots On Goal</p>
                <p>{homeStats.shots}</p>
                <p>{awayStats.faceoffPct}%</p>
                <p className="text-center">Face-off %</p>
                <p>{homeStats.faceoffPct}%</p>
                <p>{awayStats.penaltyMinutes}</p>
                <p className="text-center">Penalty Minutes</p>
                <p>{homeStats.penaltyMinutes}</p>
                <p>{awayStats.hits}</p>
                <p className="text-center">Hits</p>
                <p>{homeStats.hits}</p>
                <p>{awayStats.blockedShots}</p>
                <p className="text-center">Blocked Shots</p>
                <p>{homeStats.blockedShots}</p>
                <p>{awayStats.giveaways}</p>
                <p className="text-center">Giveaways</p>
                <p>{homeStats.giveaways}</p>
                <p>{awayStats.takeaways}</p>
                <p className="text-center">Takeaways</p>
                <p>{homeStats.takeaways}</p>
            </div>
        </div>
    );
};

export default GameSummary;
